import React from 'react'
import { useToastContext } from './ToastProvider'
import { Toast } from './Toast'

export const ToastContainer: React.FC = () => {
  const { toasts } = useToastContext()

  // Memoize the toast list to prevent unnecessary re-renders
  const toastElements = React.useMemo(() => {
    return toasts.map(toast => {
      try {
        return <Toast key={toast.id} toast={toast} />
      } catch (error) {
        // Log error in development but don't crash
        if (import.meta.env.DEV) {
          console.error('Error rendering toast:', error)
        }
        return null
      }
    })
  }, [toasts])

  return <>{toastElements}</>
}